export default {
    md: 768,
    lg: 1200,
    xl: 1440
};
